// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3uBLE","signatureButtonsRight":"ModalSign_signatureButtonsRight__130WY"};